import useAuth from '#/hooks/useAuth';
import useServiceStats from '#/hooks/useServiceStats';
import usePartner from './usePartner';

type ServiceKey =
  | 'living_will'
  | 'power_of_attorney'
  | 'last_will'
  | 'marriage_contract'
  | 'cohabitation_agreement'
  | 'digital_footprint'
  | 'asset_register'
  | 'tax_folder';
const useDisableDownloads = (serviceKey: ServiceKey) => {
  const { user } = useAuth();
  const { downloaded } = useServiceStats();
  const { partnerKey } = usePartner();
  const isFromFinFinder = partnerKey === 'finfinder';

  const isLivingWill = serviceKey === 'living_will';

  const handleDisableDownloads = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const { subscription_package, is_subscribed } = user;

    // For users with no subscription, disable downloads entirely - they can create but not download
    if (subscription_package === 'no' && !is_subscribed) {
      return true;
    }

    if (subscription_package === 'starter') {
      // Starter package allows living_will, power_of_attorney, last_will, marriage_contract, cohabitation_agreement
      // BUT NOT digital_footprint, asset_register, tax_folder
      const disallowedServices = [
        'digital_footprint',
        'asset_register',
        'tax_folder',
      ];
      return disallowedServices.includes(serviceKey);
    }

    if (subscription_package === 'free') {
      if (downloaded?.length === 3) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        return !downloaded.includes(serviceKey);
      }
    }

    return false;
  };

  return { handleDisableDownloads };
};

export default useDisableDownloads;
